import { Component, OnInit, Input } from '@angular/core';

@Component({
  selector: 'app-pagination',
  templateUrl: './pagination.component.html',
  styleUrls: ['./pagination.component.scss']
})
export class PaginationComponent implements OnInit {
  @Input() amount: number = 0;
  @Input() currentPage: number = 1;
  @Input() perPage: number = 12;
  @Input() prefix: string = '/';

  // get nextUrl() {
  //   return `${this.prefix ? '/' : ''}${this.prefix}?page=${this.currentPage + 1}`;
  // }
  // get prevUrl() {
  //   return `${this.prefix ? '/' : ''}${this.prefix}?page=${this.currentPage - 1}`;
  // }

  constructor() { }

  ngOnInit() {
  }

  pages() {
    return Math.ceil(this.amount / this.perPage);
  }

}
